<template>
  <div>
    <app-history @clicked="openZavabet" title="ضوابط رتبه بندی شهریه" v-if="!showDetails" />

    <div v-if="isMobile">
      <div v-if="!showDetails">
        <app-search />
        <app-receipt v-for="index in salaries.length" :key="index" :index="index - 1" :receipt="salaries[index - 1]"
          :selectedReceipt="selectedReceipt" @clicked="onClickReceipt" :showDetails="false">
        </app-receipt>
      </div>
      <div v-else>
        <app-receipt :index="selectedReceipt" :receipt="salaries[selectedReceipt]" :selectedReceipt="selectedReceipt"
          :showDetails="true">
        </app-receipt>
        <div class="courses">
          <app-detail :details="filterType(1)" classType="mazaya"
            :title="'اقلام ' + salaries[selectedReceipt].TypeName">
          </app-detail>
          <app-detail :details="filterType(2)" classType="kosoorat" title="کسورات">
          </app-detail>
        </div>
      </div>
    </div>
    <div v-else>
      <v-data-table :items="salaries" :headers="salaryHeaders" item-key="order" class="elevation-1 rounded" show-expand
        single-expand :no-data-text="tableText" @item-expanded="onExpand" :item-class="rowClass" :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
        }">
        <template v-slot:[`item.Daryafti`]="{ item }">
          {{ normalizeNumber(item.Daryafti) }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <app-half-detail :items="filterType(1)" :tableText="tableText" :title="'اقلام ' + item.TypeName">
            </app-half-detail>
            <app-half-detail :items="filterType(2)" :tableText="tableText" title="کسورات">
            </app-half-detail>
          </td>
        </template>
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Receipt from "./Receipt";
import Detail from "./Detail";
import HalfDetail from "./HalfDetail";
import Search from "@/components/Search";
import { toArabicCharacter } from "@/utils/constants";
import HistoryButton from "@/components/HistoryButton";
export default {
  components: {
    appSearch: Search,
    appReceipt: Receipt,
    appDetail: Detail,
    appHalfDetail: HalfDetail,
    appHistory: HistoryButton,
  },
  data() {
    return {
      selectedReceipt: -1,
      salaryHeaders: [
        {
          text: "تاریخ",
          value: "Tarikh",
          width: "15%",
        },
        {
          text: "نوع",
          value: "TypeName",
          width: "15%",
        },
        {
          text: "عنوان",
          value: "Title",
          width: "40%",
        },
        {
          text: "مبلغ",
          value: "Daryafti",
          width: "25%",
        },
        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
    };
  },
  created() {
    this.$store.dispatch("getSalaries");
  },
  computed: {
    searchInput() {
      return this.$store.getters.searchInput;
    },
    salaries() {
      var salaries = this.$store.getters.salaries;
      return salaries.filter((single) => {
        return single.Title.toLowerCase().includes(
          toArabicCharacter(this.searchInput)
        );
      });
    },
    showDetails() {
      return this.selectedReceipt > -1;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  methods: {
    openZavabet() {
      window.open("https://hozehkh.com/res/zavabet.pdf");
    },
    rowClass(item) {
      let rowClass = item.Type == 2 ? "no-expand" : "";
      return rowClass;
    },
    /**
     * get class students
     */
    onClickReceipt(index) {
      this.$store.commit("SET_SNACKBAR_SHOW", false);

      if (this.salaries[index].Type != 2) {
        let relatedID = this.salaries[index].RelatedId;
        let type = this.salaries[index].Type;
        window.scrollTo(0, 0);
        this.$store.dispatch("getSalaryDetails", {
          relatedID: relatedID,
          type: type,
        });
        this.$store.commit("SET_HEADER_TITLE", "");
        this.$router.push({
          query: {

            index: index
          }
        });
      } else {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "جزییاتی برای نمایش وجود ندارد."
        );
      }

    },
    filterType(type) {
      var details = this.$store.getters.salaryDetails;
      return details.filter((single) => {
        return single.Type == type;
      });
    },
    normalizeNumber(number) {
      const locale = Math.abs(Number(number)).toLocaleString();
      return locale + (number < 0 ? "-" : "") + " ریال";
    },

    onExpand(event) {
      if (event.value) {
        let relatedID = event.item.RelatedId;
        let type = event.item.Type;

        this.$store.dispatch("getSalaryDetails", {
          relatedID: relatedID,
          type: type,
        });
      }
    },
  },
  watch: {

    '$route'(to, from) {
      this.selectedReceipt = this.$route.query.index ?? -1;

    }
  },

};
</script>
